export const CREDITOR_WORKFLOW_CONTAINER_TAG_NAME = 'creditor-workflow-container';
